import { render, staticRenderFns } from "./AddressElement.vue?vue&type=template&id=2de20af4&"
import script from "./AddressElement.vue?vue&type=script&lang=js&"
export * from "./AddressElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports